<template>
</template>
<script>
export default {
  props: {
    javascript: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
    };
  },
  mounted() {
       $("head").append(this.javascript);
  },
  methods: {
  },
  computed: {
  }
};
</script>
